module.exports = __webpack_public_path__ + "media/שתה.6a6e712b.mp3";